import React from 'react';
import { Box } from '@mui/material';

const StepProgress = ({ currentStep, totalSteps }) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '450px',
        height: '4px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '2px',
        overflow: 'hidden',
        marginBottom: 4
      }}
    >
      <Box
        sx={{
          width: `${((currentStep + 1) / totalSteps) * 100}%`,
          height: '100%',
          background: (theme) => theme.gradients.primary,
          transition: 'width 0.3s ease'
        }}
      />
    </Box>
  );
};

export default StepProgress;